<template>
	<div class="video-box">
		<video v-if="!page.vimeo" class="mzd-video" preload="metadata" controls controlslist="nodownload">
			<source :src="page.url">Your browser does not support the video tag.
		</video>
		<div v-if="page.vimeo" style="padding:56.25% 0 0 0;position:relative;">
			<iframe
				:src="page.vimeo_embed"
				style="position:absolute;top:0;left:0;width:100%;height:100%;"
				frameborder="0"
				webkitallowfullscreen
				mozallowfullscreen
				allowfullscreen
			></iframe>
		</div>
	</div>
</template>

<script>
export default {
	name: "VideoMedia",
	props: ["page"],
	data() {
		return {
			// page: this.page
		};
	},

	watch: {},

	created() {},

	mounted() {},

	methods: {}
};
</script>

<style scoped>
.mzd-video {
	width: 100%;
}
.video-box {
	margin-top: 20px;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	/*min-height:1250px;*/
	/*width:1000px;*/
	/*font-size: 17pt;*/

	/*min-height:1000px;*/
	max-width: 800px;
	min-width: 400px;
	font-size: 13pt;

	/*padding:80px;*/
	-webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	-moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	background-color: white;
	color: black;
	font-family: "Times New Roman", Times, Georgia, serif;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/VideoMedia.vue